/**
 * @generated SignedSource<<4f0a7f18563a605f3a6b5cb35824c8c2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type AssignmentDueAtStatus = "DUE_SOON" | "NONE" | "OVERDUE" | "%future added value";
export type AssignmentStatus = "ACCEPTED" | "CANCELED" | "IN_PROGRESS" | "NONE" | "NOT_STARTED" | "READY_FOR_REVIEW" | "REJECTED" | "UNDER_REVIEW" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type ReviewerStatusCardPaginationFragment_flows$data = {
  readonly flows: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly assignedTo: {
          readonly " $fragmentSpreads": FragmentRefs<"ReassignReviewerPopupFragment_AssignToAvatar" | "UserAvatar_gwtUser" | "UserPriority_gwtUser">;
        } | null | undefined;
        readonly assignmentDueAtStatus: AssignmentDueAtStatus | null | undefined;
        readonly assignmentStatus: AssignmentStatus;
        readonly dueAt: Date | null | undefined;
        readonly flowReviewers: {
          readonly nodes: ReadonlyArray<{
            readonly reviewer: {
              readonly " $fragmentSpreads": FragmentRefs<"ReassignReviewerPopupFragment_ReviewerAvatar" | "UserAvatar_gwtUser">;
            } | null | undefined;
          }>;
        };
        readonly name: string;
        readonly rowId: UUID;
        readonly " $fragmentSpreads": FragmentRefs<"FlowLink_flow" | "StatusChip_flow">;
      };
    }>;
    readonly totalCount: number;
  } | null | undefined;
  readonly " $fragmentType": "ReviewerStatusCardPaginationFragment_flows";
};
export type ReviewerStatusCardPaginationFragment_flows$key = {
  readonly " $data"?: ReviewerStatusCardPaginationFragment_flows$data;
  readonly " $fragmentSpreads": FragmentRefs<"ReviewerStatusCardPaginationFragment_flows">;
};

import ReviewerStatusCardPaginationQuery_Refetchable_graphql from './ReviewerStatusCardPaginationQuery_Refetchable.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "flows"
],
v1 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "UserAvatar_gwtUser"
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "count"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cursor"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "flowFilter"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "flowsOrderBy"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "count",
          "cursor": "cursor"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [],
      "operation": ReviewerStatusCardPaginationQuery_Refetchable_graphql
    }
  },
  "name": "ReviewerStatusCardPaginationFragment_flows",
  "selections": [
    {
      "alias": "flows",
      "args": [
        {
          "kind": "Variable",
          "name": "filter",
          "variableName": "flowFilter"
        },
        {
          "kind": "Variable",
          "name": "orderBy",
          "variableName": "flowsOrderBy"
        }
      ],
      "concreteType": "FlowsConnection",
      "kind": "LinkedField",
      "name": "__ReviewerStatusCard_flows_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "FlowsEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Flow",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "rowId",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "FlowLink_flow"
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "GwtUser",
                  "kind": "LinkedField",
                  "name": "assignedTo",
                  "plural": false,
                  "selections": [
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "UserPriority_gwtUser"
                    },
                    (v1/*: any*/),
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "ReassignReviewerPopupFragment_AssignToAvatar"
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "FlowReviewersConnection",
                  "kind": "LinkedField",
                  "name": "flowReviewers",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "FlowReviewer",
                      "kind": "LinkedField",
                      "name": "nodes",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "GwtUser",
                          "kind": "LinkedField",
                          "name": "reviewer",
                          "plural": false,
                          "selections": [
                            (v1/*: any*/),
                            {
                              "args": null,
                              "kind": "FragmentSpread",
                              "name": "ReassignReviewerPopupFragment_ReviewerAvatar"
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "StatusChip_flow"
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "dueAt",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "assignmentStatus",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "assignmentDueAtStatus",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "a979594adb569aa806b68f2e9fd940d0";

export default node;
